export default __webpack_public_path__ + "static/media/tool-icon-shirt-orange.408907c7.svg";